import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import cx from 'classnames';
import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Input } from 'semantic-ui-react';

import Button from '@package/components/Button';
import Icon from '@package/components/Icon';

const messages = defineMessages({
  search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
  searchSite: {
    id: 'Search Site',
    defaultMessage: 'Search Site',
  },
});

const SearchWidget = (props) => {
  const intl = useIntl();

  const [text, setText] = useState('');
  const [open, setOpen] = useState(false);

  const history = useHistory();
  const onChangeText = (event, { value }) => {
    setText(value);
  };
  const { onSubmit = () => {} } = props;

  const currentLang = useSelector((state) => state.intl.locale);

  const searchUrl = `/${toBackendLang(currentLang)}/search`;

  const submitSearch = (event) => {
    history.push(`${searchUrl}?SearchableText=${encodeURIComponent(text)}`);
    // reset input value
    setText('');
    setOpen(false);
    onSubmit();
    event.preventDefault();
  };

  return (
    <div className="search-widget">
      <Button circle link className="trigger" onClick={() => setOpen(!open)}>
        <Icon bold name={open ? 'close' : 'search'} />
      </Button>

      <form
        className={cx({ open })}
        action={`${searchUrl}/search`}
        onSubmit={submitSearch}
      >
        <Icon name="search" bold className="label-icon" />
        <Input
          aria-label={intl.formatMessage(messages.search)}
          onChange={onChangeText}
          name="SearchableText"
          value={text}
          autoComplete="off"
          placeholder={intl.formatMessage(messages.searchSite)}
          title={intl.formatMessage(messages.search)}
        />
        <Button
          type="submit"
          primary
          circle
          aria-label={intl.formatMessage(messages.search)}
        >
          {/* <Icon name="east" bold /> */}
          <Icon name="arrow_forward" bold />
        </Button>
      </form>
    </div>
  );
};

export default SearchWidget;
